@if (!isEmbeddedView) {
<header class="app-header">
  <!-- ── Left: page title ── -->
  <div class="header-start">
    <h1 class="page-title">{{ (headerData$ | async)?.title }}</h1>
  </div>

  <!-- ── Right: avatar trigger ── -->
  <div class="user-zone">
    <button
      #avatarBtnRef
      type="button"
      class="account-trigger"
      [class.is-open]="isProfileOpen"
      [attr.aria-expanded]="isProfileOpen"
      aria-haspopup="true"
      aria-controls="profileMenu"
      [attr.aria-label]="'Account menu for ' + profileData.userName"
      (click)="toggleProfileMenu($event)"
    >
      <span class="account-trigger-avatar">
        <img src="assets/images/common/user_profile.jpg" alt="" />
      </span>
    </button>
  </div>
</header>

<!-- ── Profile dropdown — rendered OUTSIDE <header> so position:fixed is
     relative to the viewport root and cannot be trapped by any ancestor
     transform or stacking context (e.g. mat-table sticky rows). ── -->
<div
  #profileMenuRef
  class="profile-menu"
  [class.open]="isProfileOpen"
  id="profileMenu"
  role="dialog"
  aria-label="Account menu"
>
  <!-- User info -->
  <div class="profile-user">
    <div class="profile-avatar" aria-hidden="true">
      <img src="assets/images/common/user_profile.jpg" alt="" />
    </div>
    <div class="profile-meta">
      <div class="profile-name">{{ profileData.userName }}</div>
      <div class="profile-email">{{ profileData.email }}</div>
      @if (roleLabel) {
      <span class="profile-role-badge">{{ roleLabel }}</span>
      }
    </div>
  </div>

  <!-- Logout -->
  <button type="button" class="profile-logout" (click)="logout()">
    Logout
  </button>
</div>

<!-- ── Breadcrumbs ── -->
@if (getNumber((headerData$ | async)?.breadcrumbs) > 1) {
<nav class="breadcrumb-container" aria-label="Breadcrumb">
  @for (breadcrumb of (headerData$ | async)?.breadcrumbs; track breadcrumb.url)
  { @if (!$first) {
  <span class="breadcrumb-separator" aria-hidden="true">
    <span class="breadcrumb-chevron"></span>
  </span>
  }
  <span
    (click)="!$last && navigate(breadcrumb.url)"
    class="breadcrumb"
    [class.breadcrumb--current]="$last"
    [class.breadcrumb--link]="!$last"
  >
    {{ breadcrumb.label }}
  </span>
  }
</nav>
} }
